import type {FleetDeploymentStatus} from 'src/assets/rental-assets/schemas'

export function formatDeploymentStatusLabel(status: FleetDeploymentStatus): string {
    if (status.status === 'available') {
        return 'Not deployed'
    }
    if (status.status === 'deployed') {
        return status.locationLabel ? `Deployed at ${status.locationLabel}` : 'Deployed'
    }
    if (status.status === 'picked_up') {
        return 'Picked up'
    }
    return 'Dispatched'
}
